<template>
  <div
    :style="{
      background: restaurant.welcomePageBackground
        ? `url('${restaurant.welcomePageBackground.url}')`
        : null,
    }"
    style="
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
    "
    class="relative flex min-h-[var(--screen-height)] flex-col justify-end bg-theme-background"
  >
    <div style="padding-top: var(--safe-area-inset-top)">
      <div class="p-4"></div>
    </div>
    <div class="flex-1"></div>
    <div class="mb-14 mt-4 flex justify-center">
      <RouterLink
        :to="{ name: 'home' }"
        class="menu-button-primary !font-extrabold uppercase"
      >
        {{ trans('Open menu') }}
      </RouterLink>
    </div>
  </div>
</template>

<script setup lang="ts">
import { trans } from '@menu/Utils/i18n';
import getRestaurant from '@menu/Utils/getRestaurant';

const restaurant = getRestaurant();
</script>
